import { render, staticRenderFns } from "./dupont.vue?vue&type=template&id=5895ef9c&scoped=true&"
import script from "./dupont.vue?vue&type=script&lang=js&"
export * from "./dupont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895ef9c",
  null
  
)

export default component.exports